import axios from '@/axios.config.js';

class ClassService {
    createClass(cancelToken, classObj) {
        return axios
            .post('classes',
                {
                    name: classObj.name,
                    course_id: classObj.course_id,
                    teacher_id: classObj.teacher_id,
                    school_id: classObj.school_id,
                    grade: classObj.grade,
                    times: classObj.times,
                },
                {
                    cancelToken: cancelToken.token
                }
            )
            .then(response => {
                return response.data;
            });
    }

    updateClass(cancelToken, classObj) {
        return axios
            .patch(`classes/${classObj.id}`,
                {
                    name: classObj.name,
                    course_id: classObj.course_id,
                    teacher_id: classObj.teacher_id,
                    school_id: classObj.school_id,
                    grade: classObj.grade,
                    times: classObj.times,
                },
                {
                    cancelToken: cancelToken.token
                }
            )
            .then(response => {
                return response.data;
            });
    }

    deleteClass(cancelToken, classId) {
        return axios
            .delete(`classes/${classId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listClassesByCourseId(cancelToken, courseId) {
        return axios
            .get(`courses/${courseId}/classes`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getClass(cancelToken, classId) {
        return axios
            .get(`classes/${classId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listClasses(cancelToken) {
        return axios
            .get('classes', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    syncClassStudents(cancelToken, classId, data) {
        return axios
            .post(`classes/${classId}/students`, {students: data.students,}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listRooms(cancelToken, classId) {
        return axios
            .get(`classes/${classId}/sky-rooms`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createLicense(cancelToken, licenseObj) {
        return axios
            .post('classes/licenses',
                {
                    user_id: licenseObj.user_id,
                    license: licenseObj.license,
                },
                {
                    cancelToken: cancelToken.token
                }
            )
            .then(response => {
                return response.data;
            });
    }

    updateLicense(cancelToken, licenseObj) {
        return axios
            .patch(`classes/licenses/${licenseObj.id}`,
                {
                    user_id: licenseObj.user_id,
                    license: licenseObj.license,
                },
                {
                    cancelToken: cancelToken.token
                }
            )
            .then(response => {
                return response.data;
            });
    }

    deleteLicense(cancelToken, licenseId) {
        return axios
            .delete(`classes/licenses/${licenseId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listLicenses(cancelToken) {
        return axios
            .get('classes/licenses', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getLicense(cancelToken, licenseId) {
        return axios
            .get(`classes/licenses/${licenseId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    myLicense(cancelToken) {
        return axios
            .get('classes/licenses/me', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new ClassService();